//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import * as OnegameAction from "../one_game/actions";
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Delete user Notification ----------

export const handleGamePopupNotify = (data) => async (dispatch) => {
     dispatch(OnegameAction.setPlayGameModal({ open: true, data }));
}